import CurrencyManager from "../currency/currencyManager";


export const CURRENCY = {
    CurrencyManager: new CurrencyManager()
};